/**
 * @generated SignedSource<<04f685f7427f29a62cf3c7bcad963811>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topStoriesItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
  readonly " $fragmentType": "topStoriesItemContent";
};
export type topStoriesItemContent$key = {
  readonly " $data"?: topStoriesItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"topStoriesItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topStoriesItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentItemRenderContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "aa3361f1756afa7246b7b8e1b4ef8682";

export default node;
